"use client";

import { useEffect } from "react";

const BLAZEO_SRC = 'https://blazeo.com/scripts/invitation.ashx?company=BreyerLawOffices';
const BLAZEO_HOST = 'blazeo.com';

export default function BlockBlazeoWidget() {
  useEffect(() => {
    // 1) Remove the known script tag (present or added later)
    const removeScriptTags = () => {
      document
        .querySelectorAll(`script[src^="${BLAZEO_SRC}"], script[src*="${BLAZEO_HOST}"]`)
        .forEach((el) => el.remove());
    };

    // 2) Remove likely injected DOM (be conservative and targeted)
    const removeInjectedDom = () => {
      const selectors = [
        'iframe[src*="blazeo.com"]',
        'link[href*="blazeo.com"]',
        '[id*="blazeo"]',
        '[class*="blazeo"]',
        '[id*="invitation"]',
        '[class*="invitation"]',
      ];
      document.querySelectorAll(selectors.join(",")).forEach((el) => {
        // Keep your app safe: only remove nodes not inside your app containers
        (el as HTMLElement).remove();
      });
    };

    // 3) MutationObserver to catch late/async injection
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          // a) script tags
          if (
            node.tagName === "SCRIPT" &&
            (node as HTMLScriptElement).src &&
            ((node as HTMLScriptElement).src.startsWith(BLAZEO_SRC) ||
              (node as HTMLScriptElement).src.includes(BLAZEO_HOST))
          ) {
            node.remove();
            return;
          }

          // b) iframes/links/elements with identifiable id/class
          if (
            node.matches?.('iframe[src*="blazeo.com"], link[href*="blazeo.com"], [id*="blazeo"], [class*="blazeo"], [id*="invitation"], [class*="invitation"]')
          ) {
            node.remove();
            return;
          }

          // c) sometimes widgets append children later
          if (node.querySelector) {
            const inner = node.querySelector(
              'script[src*="blazeo.com"], iframe[src*="blazeo.com"], link[href*="blazeo.com"], [id*="blazeo"], [class*="blazeo"], [id*="invitation"], [class*="invitation"]'
            );
            if (inner) {
              // Remove script first so it can’t run again
              node.querySelectorAll('script[src*="blazeo.com"]').forEach((s) => s.remove());
              node.remove();
            }
          }
        });
      }
    });

    // Initial pass + start observing
    removeScriptTags();
    removeInjectedDom();
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Cleanup observer on unmount (leaves other pages alone)
    return () => mo.disconnect();
  }, []);

  return null;
}
